import React, { useState, useEffect, useContext } from "react";
import { useStyleFormInscript } from "./FormulaireInscription.css";
import rest from "../../rest";
import { connect, useDispatch, useSelector } from "react-redux";
/* import SearchableSelect from 'SearchableSelect' */
import AppContext from "../appContext";
import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormLabel,
} from "@material-ui/core";
import {
  InputAdornment,
  InputLabel,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import LanguageIcon from "@material-ui/icons/Language";
import PhoneIcon from "@material-ui/icons/Phone";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";
import WorkIcon from "@material-ui/icons/Work";
import WcIcon from "@material-ui/icons/Wc";
import FiberNewIcon from "@material-ui/icons/FiberNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTshirt } from "@fortawesome/free-solid-svg-icons";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import LanguagesSelect from "../langues/languagesList.json";
import SpecialTextField from "./specialTextField";
import SpecialInputmask from "./speciaInputMask";
import SpecialSelect from "./specialSelect";
import countryList from "./countryList";
import { useModal } from "../general/modalContext";
import MultiModal from "../general/modals/multiOptModal";
import { useStylesGlobal } from "../../pages/GlobalStyle.css";
import PhotoProfil from "../PhotoProfil/PhotoProfil";
import useRedirectAndReload from "../general/redirectReload";

const validationFixedField = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];

// Debut fonction
const FormulaireBenevole = ({
  idBenevole,
  setShowForm,
  setSnack,
  fromProfil,
  row = [],
  userMail,
  fromDoublon,
}) => {
  const classes = useStyleFormInscript();
  const myContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [openUpdatePsw, setOpenUpdatePsw] = useState(false);
  const [person, setPerson] = useState({
    Person_ID: 0,
    Person_Name: "",
    Person_Firstname: "",
    Person_Birth: "",
    Person_Address: "",
    Person_Address_2: "",
    Person_Zip: "",
    Person_Locality: "",
    Person_Country: "",
    Person_Gender: "",
    Person_Email: userMail || "",
    Person_Phone_Mobile: "",
    Person_Phone_Pers: "",
    Person_Phone_Pro: "",
    Person_Job: "",
    Person_Tshirt: "",
    Person_AcceptNewsletter: false,
    Person_Commentaire: "",
    Person_Attributs: [],
    Person_Langue: [],
  });
  const [listAttributs, setListAttributs] = useState(null);
  const [attributeLoaded, setAttributeLoaded] = useState(false);
  const manifParams = useSelector((state) => state.manif);
  const currentUser = useSelector((state) => state.user);
  const [fieldComplementaireConfig, setFieldComplementaireConfig] = useState(
    []
  );
  const [paramsConfig, setParamsConfig] = useState({});
  const [fieldComplementaireValue, setFieldComplementaireValue] = useState([]);
  const [fieldValidation, setFieldValidation] = useState(validationFixedField);
  //update psw form
  const [psw, setPsw] = useState("");
  const [pswConfirm, setPswConfirm] = useState("");
  const [pswError, setPswError] = useState(false);
  const [pswConfirmError, setPswConfirmError] = useState(false);
  const [pswErrorMsg, setPswErrorMsg] = useState("");
  const [pswConfirmErrorMsg, setPswConfirmErrorMsg] = useState("");
  const [hisAdmin, setHisAdmin] = useState(false);
  const [obligatoire, setFieldObligatoir] = useState({});
  const dispatch = useDispatch();
  const [doublon, setDoublon] = useState([]);
  const [loadPersonIsDown, setLoadPersonIsDown] = useState(false);

  const { openModal, closeModal } = useModal();
  const classesGlobal = useStylesGlobal();
  const [photoProfil, setPhotoProfil] = useState(false);
  const [photoError, setPhotoError] = useState(true);
  const [newPersonnID, setNewPersonID] = useState(0);

  const [complemantaireError, setComplemntaireError] = useState([]);
  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const redirectAndReload = useRedirectAndReload({
    url: "/index.html",
    typeLink: "fromProfile",
  });

  // const redirectLesBenevol = useRedirectAndReload({ url: "/les_benevoles.html", typeLink: "fromProfile", });

  const redirectWishlist = useRedirectAndReload({
    url: "/inscriptionWishlit.html",
    typeLink: "fromProfile",
  });

  /* const redirectPlanning = useRedirectAndReload({url: "/planning.html", typeLink: "fromProfile", }); */

  useEffect(() => {
    if (listAttributs !== null) {
      setAttributeLoaded(true);
    }
  }, [listAttributs]);

  useEffect(() => {
    setHisAdmin(
      currentUser.User.User_Administrator &&
        currentUser.User.User_Person_ID !== idBenevole
    );
  }, [currentUser, idBenevole]);

  useEffect(() => {
    let tmp = [];
    let tmpError = JSON.parse(JSON.stringify(validationFixedField));

    for (
      let index = 0;
      index < manifParams.manifInfosProfil?.InfosComplementaires?.length;
      index++
    ) {
      const info = manifParams.manifInfosProfil?.InfosComplementaires[index];
      const value = person.Person_InfosComples?.InfosComplementaires
        ? person.Person_InfosComples?.InfosComplementaires.find(
            (x) => x.idInfoComple === info.idInfoComple
          )?.valeur || ""
        : "";
      tmp.push({ id: info.idInfoComple, value });
      if (info.champsObligatoireInfoComple) {
        tmpError.push(false);
      }
    }
    setFieldValidation(tmpError);

    if (person.Person_InfosComples?.InfosComplementaires) {
      setFieldComplementaireValue(tmp);
    }

    setFieldComplementaireConfig(
      manifParams?.manifInfosProfil?.InfosComplementaires
    );
    setFieldObligatoir(manifParams?.manifInfosProfil?.ChampObligatoire);
    setParamsConfig(manifParams?.manifParams);
  }, [manifParams, person]);

  useEffect(() => {
    rest.get("/attribut/liste.json").then((response) => {
      setListAttributs(response.data);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (row?.length > 0) setDoublon(row);
  }, [row]);

  useEffect(() => {
    if (!photoError && fromProfil) {
      redirectWishlist();
    }
  }, [photoError, fromProfil, redirectWishlist]);

  useEffect(() => {
    if (attributeLoaded) {
      rest
        .post(`/benevols/GetProfil.json`, { vIdPers: idBenevole })
        .then((response) => {
          if (response.data.Person_Langue.length > 0) {
            var newArray = LanguagesSelect.filter(function (el) {
              return response.data.Person_Langue.indexOf(el.value) >= 0;
            });
            response.data.Person_Langue = newArray;
          }

          if (response.data.Person_Attributs.length > 0) {
            var newArray2 = listAttributs.filter(function (el) {
              return (
                response.data.Person_Attributs.map((item) => item.id).indexOf(
                  el.id
                ) > -1
              );
            });
            response.data.Person_Attributs = newArray2;
          }
          response.data.Person_AcceptNewsletter = response.data
            .Person_AcceptNewsletter
            ? "true"
            : "false";
          if (response.data.Person_ID !== 0)
            // ne pas supprimer l'email de par defaut du profil
            setPerson(response.data);

          setLoadPersonIsDown(true);

          setLoading(false);
          if (doublon.length > 0) {
            fetchPersonnes();
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idBenevole, attributeLoaded, listAttributs]);

  const fetchPersonnes = async () => {
    try {
      const data = await fetchDoublonProfiles(doublon);
      setDoublon([...data]);
    } catch (error) {
      console.error(error);
    }
  };
  // Fonction pour récupérer les profils des doublons
  const fetchDoublonProfiles = async (doublonCopy) => {
    const updatedDoublon = await Promise.all(
      doublonCopy.map(async (row) => {
        if (doublonCopy.some((element) => element.ID === row.ID)) {
          try {
            const response = await rest.post(`/benevols/GetProfil.json`, {
              vIdPers: row.ID,
            });
            row.personne = response.data; // Mettre à jour le champ "personne" dans la copie de doublon
            return row; // Retourner l'objet mis à jour
          } catch (error) {
            console.error(
              "Une erreur s'est produite lors de la récupération du profil :",
              error
            );
            return row; // En cas d'erreur, retourner l'élément actuel sans modification
          }
        } else {
          // Si l'élément n'a pas besoin d'être mis à jour, le retourner tel quel
          return row;
        }
      })
    );
    return updatedDoublon;
  };

  const handleFormChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const idInput = target.id;
    if (!idInput) {
      setPerson({ ...person, [target.name]: value });
    } else {
      setPerson({ ...person, [idInput]: value });
    }
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleAttrChange = (event) => {
    // Liste des attributs sélectionnés
    const selectedAttributes = event.target.value;

    // Initialiser un Set pour les identifiants uniques et un tableau pour les attributs uniques
    const uniqueIds = new Set();
    let uniqueArray = [];

    // Ajouter ou retirer les attributs de uniqueArray selon leur sélection
    selectedAttributes.forEach((attr) => {
      const identifier = attr.id || attr.value;
      if (uniqueIds.has(identifier)) {
        // Si l'identifiant existe déjà, retirer l'élément correspondant
        uniqueArray = uniqueArray.filter(
          (item) => (item.id || item.value) !== identifier
        );
        uniqueIds.delete(identifier);
      } else {
        // Sinon, ajouter l'élément
        uniqueIds.add(identifier);
        uniqueArray.push({ ...attr, value: identifier, id: identifier });
      }
    });
    // Mettre à jour l'état avec les attributs uniques sélectionnés
    setPerson({ ...person, Person_Attributs: uniqueArray });
  };

  const handleLangueChange = (event) => {
    setPerson({ ...person, Person_Langue: event.target.value });
  };

  const hendelChangeInfoComp = (id, value) => {
    const tmp = structuredClone(fieldComplementaireValue);

    let v = tmp.find((x) => x.id === id);
    if (v) v.value = value;
    else tmp.push({ id, value });
    setFieldComplementaireValue([...tmp]);
  };

  const saveInfosBen = (event) => {
    let tmpError = JSON.parse(JSON.stringify(fieldValidation));
    tmpError[0] = person.Person_Name === "";
    tmpError[1] = person.Person_Firstname === "";
    tmpError[2] = person.Person_Birth === "" && !hisAdmin;
    if (manifParams.manifInfosProfil.ChampDemande[0].champAddress) {
      tmpError[3] =
        person.Person_Address === "" &&
        !hisAdmin &&
        obligatoire?.champAddress_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champAddress2) {
      tmpError[4] =
        person.Person_Address_2 === "" &&
        obligatoire?.champAddress2_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champZip) {
      tmpError[5] =
        person.Person_Zip === "" &&
        !hisAdmin &&
        obligatoire?.champZip_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champLocality) {
      tmpError[6] =
        person.Person_Locality === "" &&
        !hisAdmin &&
        obligatoire?.champLocality_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champCountry) {
      tmpError[7] =
        person.Person_Country === "" &&
        !hisAdmin &&
        obligatoire?.champCountry_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champPhone) {
      tmpError[9] =
        person.Person_Phone_Mobile === "" &&
        person.Person_Phone_Pers === "" &&
        person.Person_Phone_Pro === "" &&
        !hisAdmin &&
        obligatoire?.champPhone_obligatoire;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champJob) {
      tmpError[10] =
        person.Person_Job === "" &&
        !hisAdmin &&
        obligatoire?.champJob_obligatoire;
    }
    if (paramsConfig.Tshirt) {
      tmpError[11] = person.Person_Tshirt === "" && !hisAdmin;
    }
    if (manifParams.manifInfosProfil.ChampDemande[0].champLangue) {
      tmpError[12] =
        person.Person_Langue.length === 0 &&
        !hisAdmin &&
        obligatoire?.champLangue_obligatoire;
    }

    tmpError[8] = person.Person_Email === "" && !hisAdmin;
    tmpError[13] = person.Person_Gender === "";
    tmpError[14] = person.Person_AcceptNewsletter === "";

    for (let index = 0; index < fieldComplementaireConfig.length; index++) {
      if (
        fieldComplementaireConfig[index].champsObligatoireInfoComple &&
        !hisAdmin
      ) {
        const fieldValue = fieldComplementaireValue.find(
          (x) => x.id === fieldComplementaireConfig[index].idInfoComple
        )?.value;

        const boolError = fieldValue === "" || fieldValue === undefined;
        tmpError[15 + index] = boolError;

        // Mettre à jour l'état des erreurs
        setComplemntaireError((prev) => {
          const newErrors = [...prev];
          newErrors[index] = { error: boolError, index };
          return newErrors;
        });
      }
    }

    console.log(tmpError);

    setFieldValidation(tmpError);

    if (!tmpError.includes(true)) {
      setLoading(true);
      var paramsData = {
        vIdPerson: person.Person_ID,
        vProfileName: person.Person_Name,
        vProfileFirstname: person.Person_Firstname,
        vProfileSexe: person.Person_Gender,
        vProfileBirth: person.Person_Birth,
        vProfileEmail: person.Person_Email,
        vProfileAddress: person.Person_Address,
        vProfileAddress2: person.Person_Address_2,
        vProfileLocality: person.Person_Locality,
        vProfileZIP: person.Person_Zip,
        vProfileCountry: person.Person_Country,
        vProfilePhoneMobile: person.Person_Phone_Mobile,
        vProfilePhonePers: person.Person_Phone_Pers,
        vProfilePhonePro: person.Person_Phone_Pro,
        vProfileJob: person.Person_Job,
        vTailleTShirt: person.Person_Tshirt,
        vProfileComment: person.Person_Commentaire,
        vPersonAttribut: JSON.stringify(person.Person_Attributs),
        vProfilLangue: JSON.stringify(person.Person_Langue),
        vAcceptNewsletter: person.Person_AcceptNewsletter,
      };
      if (doublon.length > 0) {
        // si il existe des doublon on modifie puis fusionne
        paramsData.vDoublon = JSON.stringify(doublon);
      }

      paramsData.InfosComplementaires = [];

      for (let index = 0; index < fieldComplementaireConfig.length; index++) {
        const valeur = fieldComplementaireValue.find(
          (x) => x.id === fieldComplementaireConfig[index].idInfoComple
        );
        paramsData.InfosComplementaires.push({
          nom: fieldComplementaireConfig[index].idInfoComple,
          valeur: valeur.value,
        });
      }

      // Convert InfosComplementaires to JSON string
      paramsData.InfosComplementaires = JSON.stringify(
        paramsData.InfosComplementaires
      );
      rest
        .post(
          "/benevols/profilSave.json",
          encodeURIComponent(JSON.stringify(paramsData))
        )
        .then(async function (response) {
          if (!response.data.error) {
            setSnack({
              message: response.data.message,
              show: true,
              severity: "success",
            });
            if (setShowForm) {
              setShowForm(false);
            }

            if (myContext?.setRefreshBen) {
              myContext.setRefreshBen((prev) => {
                return {
                  ...prev,
                  id: idBenevole,
                  type: "change",
                  bool: !prev?.bool,
                };
              });
            } else {
              console.error("myContext or setRefreshBen is undefined");
            }

            if (response.data.info === "newProfile") {
              setTimeout(function () {
                if (
                  manifParams.manifInfosProfil?.ChampDemande[0]
                    .champPhotoObligatoire
                ) {
                  setLoading(false);
                  setNewPersonID(response.data.Person_ID);
                  setTimeout(function () {
                    setPhotoProfil(true);
                  }, 200);
                  return;
                } else {
                  if (fromProfil) redirectAndReload();
                  if (fromDoublon) redirectAndReload(); // redirectLesBenevol();
                }
              }, 200);

              return;
            }

            await rest.get("/user/informations.json").then((response) => {
              dispatch({ type: "SET_USER", payload: response.data });
            });
          } else {
            setSnack({
              message: response.data.message,
              show: true,
              severity: "error",
            });
          }
          setLoading(false);
        });
    } else {
      setSnack({
        message: "Des erreurs ou des champs non remplis sont à corriger ",
        show: true,
        severity: "error",
      });
    }
  };

  const handleModifyPass = (event) => {
    setOpenUpdatePsw(true);
  };

  const handleCloseUpdatePsw = () => {
    setOpenUpdatePsw(false);
  };

  const handleUpdatePswConfirm = () => {
    let error = false;
    let errorPsw = false;

    if (psw === "") {
      error = true;
      setPswError(true);
      setPswErrorMsg("Champ obligatoire");
    } else {
      if (psw.length < 6) {
        error = true;
        errorPsw = true;
        setPswError(true);
        setPswErrorMsg("Le mot de passe doit contenir minimum 6 caractères.");
      } else {
        setPswError(false);
        setPswErrorMsg("");
      }
    }
    if (pswConfirm === "") {
      error = true;
      setPswConfirmError(true);
      setPswConfirmErrorMsg("Champ obligatoire");
    } else {
      if (pswConfirm.length < 6) {
        error = true;
        errorPsw = true;
        setPswConfirmError(true);
        setPswConfirmErrorMsg(
          "Le mot de passe doit contenir minimum 6 caractères."
        );
      } else {
        setPswConfirmError(false);
        setPswConfirmErrorMsg("");
      }
    }
    if (psw !== "" && pswConfirm !== "" && !errorPsw) {
      if (psw !== pswConfirm) {
        error = true;
        setPswError(true);
        setPswConfirmError(true);
        setPswErrorMsg("Les mots de passe doivent concorder.");
        setPswConfirmErrorMsg("Les mots de passe doivent concorder.");
      } else {
        setPswError(false);
        setPswConfirmError(false);
        setPswErrorMsg("");
        setPswConfirmErrorMsg("");
      }
    }

    if (!error) {
      setLoading(true);
      rest
        .post("/user/updatePassword.json", { vNewMdp: psw })
        .then(function (response) {
          if (response.data.Message !== "ok") {
            setSnack({
              message: response.data.Message,
              show: true,
              severity: "error",
            });
          } else {
            setSnack({
              message: "Mot de passe modifié avec succès.",
              show: true,
              severity: "success",
            });
            setOpenUpdatePsw(false);
          }
          setLoading(false);
        });
    }
  };

  const handleChangePsw = (event) => {
    setPsw(event.target.value?.trim());
  };
  const handleChangePswConfirm = (event) => {
    setPswConfirm(event.target.value?.trim());
  };

  const handleFusion = () => {
    const modalOption = [
      {
        handle: closeModal,
        text: "Annuler",
        variant: "outlined",
        className: classesGlobal.buttonFermer,
      },
      {
        handle: saveInfosBen,
        color: "primary",
        text: "Fusionner",
        variant: "contained",
      },
    ];

    openModal(
      "Action irréversible !",
      <MultiModal
        text={`Attention, cette action est irréversible
                `}
        options={modalOption}
      />,
      { bgcolor: "warning.main", minWidth: "40vw" }
    );
  };

  return (
    <>
      <LoadingIndicator open={loading} />

      {photoProfil && (
        <PhotoProfil
          open={photoProfil}
          setOpen={setPhotoProfil}
          idBenevole={newPersonnID}
          setPhotoError={setPhotoError}
          isColseDisabled={true}
        />
      )}
      <Grid
        container
        spacing={1}
        className={querysmDown ? classes.root2 : classes.root}
      >
        <Grid container>
          <Grid item xs={12}>
            {fromProfil && (
              <Button
                variant="contained"
                color="default"
                style={{
                  margin: "10px 0 10px 0",
                  width: querysmDown ? "100%" : "auto",
                }}
                onClick={handleModifyPass}
              >
                Modifier le mot de passe
              </Button>
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            <SpecialTextField
              id="Person_Name"
              name="Person_Name"
              dataname="Person_Name"
              label="Nom"
              type="text"
              variant="outlined"
              style={{ width: "100%" }}
              required={true}
              value={person.Person_Name}
              onChange={(e) => handleFormChange(e)}
              className={classes.inputsForm}
              error={fieldValidation[0]}
              values={
                doublon.length > 0
                  ? doublon.map((obj) => obj.personne?.Person_Name)
                  : []
              }
            />
            <SpecialTextField
              id="Person_Firstname"
              name="Person_Firstname"
              label="Prénom"
              type="text"
              variant="outlined"
              style={{ width: "100%" }}
              required={true}
              value={person.Person_Firstname}
              onChange={(e) => handleFormChange(e)}
              className={classes.inputsForm}
              error={fieldValidation[1]}
              values={
                doublon.length > 0
                  ? doublon.map((obj) => obj.personne?.Person_Firstname)
                  : []
              }
            />
            <SpecialInputmask
              mask={"99.99.9999"}
              maskPlaceholder="dd.mm.yyyy"
              maskChar="_"
              value={person.Person_Birth}
              onChange={(e) => handleFormChange(e)}
              className={classes.inputsForm}
              id="Person_Birth"
              name="Person_Birth"
              values={
                doublon.length > 0
                  ? doublon.map((obj) => obj.personne?.Person_Birth)
                  : []
              }
            >
              {() => (
                <TextField
                  id="Person_Birth"
                  name="Person_Birth"
                  label="Date de naissance (jj.mm.aaaa)"
                  type="text"
                  placeholder="jj.mm.aaaa"
                  variant="outlined"
                  style={{ width: "100%" }}
                  required={hisAdmin ? false : true}
                  value={person.Person_Birth}
                  // onChange={(e) =>  handleFormChange(e)}
                  className={classes.inputsForm}
                  error={fieldValidation[2]}
                />
              )}
            </SpecialInputmask>
            {manifParams.manifInfosProfil?.ChampDemande[0].champAddress && (
              <SpecialTextField
                id="Person_Address"
                name="Person_Address"
                label="Adresse"
                type="text"
                variant="outlined"
                style={{ width: "100%" }}
                required={
                  hisAdmin
                    ? false
                    : obligatoire?.champAddress_obligatoire
                    ? true
                    : false
                }
                error={fieldValidation[3]}
                value={person.Person_Address}
                onChange={(e) => handleFormChange(e)}
                className={classes.inputsForm}
                values={
                  doublon.length > 0
                    ? doublon.map((obj) => obj.personne?.Person_Address)
                    : []
                }
              />
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champAddress2 && (
              <span>
                <SpecialTextField
                  id="Person_Address_2"
                  name="Person_Address_2"
                  label="Complément d'adresse"
                  type="text"
                  variant="outlined"
                  style={{ width: "100%" }}
                  required={
                    hisAdmin
                      ? false
                      : obligatoire?.champAddress2_obligatoire
                      ? true
                      : false
                  }
                  error={fieldValidation[4]}
                  value={person.Person_Address_2}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Address_2)
                      : []
                  }
                />
              </span>
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champZip && (
              <span>
                <SpecialTextField
                  id="Person_Zip"
                  name="Person_Zip"
                  label="Code postal"
                  type="text"
                  variant="outlined"
                  style={{ width: "100%" }}
                  required={
                    hisAdmin
                      ? false
                      : obligatoire?.champZip_obligatoire
                      ? true
                      : false
                  }
                  error={fieldValidation[5]}
                  value={person.Person_Zip}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Zip)
                      : []
                  }
                />
              </span>
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champLocality && (
              <span>
                <SpecialTextField
                  id="Person_Locality"
                  name="Person_Locality"
                  label="Ville"
                  type="text"
                  variant="outlined"
                  style={{ width: "100%" }}
                  required={
                    hisAdmin
                      ? false
                      : obligatoire?.champLocality_obligatoire
                      ? true
                      : false
                  }
                  error={fieldValidation[6]}
                  value={person.Person_Locality}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Locality)
                      : []
                  }
                />
              </span>
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champCountry && (
              <span>
                <FormControl
                  variant="outlined"
                  style={{ width: "100%", marginLeft: "7px", marginTop: "2%" }}
                  error={fieldValidation[7]}
                >
                  <InputLabel>
                    {obligatoire?.champCountry_obligatoire ? "Pays *" : "Pays"}
                  </InputLabel>
                  <SpecialSelect
                    id="Person_Country"
                    name="Person_Country"
                    label={
                      obligatoire?.champCountry_obligatoire ? "Pays *" : "Pays"
                    }
                    style={{ width: "100%" }}
                    required={
                      hisAdmin
                        ? false
                        : obligatoire?.champCountry_obligatoire
                        ? true
                        : false
                    }
                    value={person.Person_Country}
                    onChange={(e) => handleFormChange(e)}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                    values={
                      doublon.length > 0
                        ? doublon.map((obj) => obj.personne?.Person_Country)
                        : []
                    }
                  >
                    <MenuItem value={""} key={""}></MenuItem>
                    {countryList.map((item) => (
                      <MenuItem value={item} key={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </SpecialSelect>
                </FormControl>
              </span>
            )}
          </Grid>
          <Grid item xs={12} md={5} style={{ marginLeft: "5%" }}>
            <ButtonGroup
              caria-label="outlined primary button group"
              style={{
                border: fieldValidation[13]
                  ? "1px solid red"
                  : "1px solid grey",
                width: "100%",
              }}
              className={classes.inputsForm}
            >
              <Button
                style={{
                  borderRight: fieldValidation[13]
                    ? "1px solid red"
                    : "1px solid grey",
                  color: "black",
                }}
              >
                <WcIcon />
              </Button>
              <RadioGroup
                row
                aria-label="Sexe"
                id="Person_Gender"
                name="Person_Gender"
                value={person.Person_Gender}
                onChange={(e) => handleFormChange(e)}
                style={{ margin: 8 }}
              >
                <FormControlLabel
                  value="F"
                  control={<Radio color="primary" />}
                  label="Femme"
                />
                <FormControlLabel
                  value="H"
                  control={<Radio color="primary" />}
                  label="Homme"
                />
              </RadioGroup>
            </ButtonGroup>
            {!fromProfil && (
              <SpecialTextField
                id="Person_Email"
                name="Person_Email"
                label="Email"
                type="email"
                variant="outlined"
                placeholder="exemple@domaine.ch"
                style={{ width: "100%" }}
                required={hisAdmin ? false : true}
                error={fieldValidation[8]}
                value={person.Person_Email}
                onChange={(e) => handleFormChange(e)}
                className={classes.inputsForm}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AlternateEmailIcon />
                    </InputAdornment>
                  ),
                }}
                values={
                  doublon.length > 0
                    ? doublon.map((obj) => obj.personne?.Person_Email)
                    : []
                }
              />
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champPhone && (
              <span>
                <SpecialInputmask
                  mask={"+99 99 999 99 99"}
                  maskChar="_"
                  value={person.Person_Phone_Mobile}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  id="Person_Phone_Mobile"
                  name="Person_Phone_Mobile"
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Phone_Mobile)
                      : []
                  }
                >
                  {() => (
                    <TextField
                      id="Person_Phone_Mobile"
                      name="Person_Phone_Mobile"
                      value={person.Person_Phone_Mobile}
                      label={
                        obligatoire?.champPhone_obligatoire
                          ? "Téléphone mobile *"
                          : "Téléphone mobile"
                      }
                      type="text"
                      variant="outlined"
                      style={{ width: "100%" }}
                      required={
                        hisAdmin
                          ? false
                          : obligatoire?.champPhone_obligatoire
                          ? true
                          : false
                      }
                      error={fieldValidation[9]}
                      className={classes.inputsForm}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIphoneIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </SpecialInputmask>
                <SpecialInputmask
                  mask={"+99 99 999 99 99"}
                  maskChar="_"
                  value={person.Person_Phone_Pers}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  id="Person_Phone_Pers"
                  name="Person_Phone_Pers"
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Phone_Pers)
                      : []
                  }
                >
                  {() => (
                    <TextField
                      id="Person_Phone_Pers"
                      name="Person_Phone_Pers"
                      value={person.Person_Phone_Pers}
                      label={
                        obligatoire?.champPhone_obligatoire
                          ? "Téléphone personnel *"
                          : "Téléphone personnel "
                      }
                      type="text"
                      variant="outlined"
                      style={{ width: "100%" }}
                      required={
                        hisAdmin
                          ? false
                          : obligatoire?.champPhone_obligatoire
                          ? true
                          : false
                      }
                      error={fieldValidation[9]}
                      className={classes.inputsForm}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </SpecialInputmask>
                <SpecialInputmask
                  mask={"+99 99 999 99 99"}
                  maskChar="_"
                  value={person.Person_Phone_Pro}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  id="Person_Phone_Pro"
                  name="Person_Phone_Pro"
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Phone_Pro)
                      : []
                  }
                >
                  {() => (
                    <TextField
                      id="Person_Phone_Pro"
                      name="Person_Phone_Pro"
                      value={person.Person_Phone_Pro}
                      label={
                        obligatoire?.champPhone_obligatoire
                          ? "Téléphone professionnel *"
                          : "Téléphone professionnel "
                      }
                      type="text"
                      variant="outlined"
                      style={{ width: "100%" }}
                      required={
                        hisAdmin
                          ? false
                          : obligatoire?.champPhone_obligatoire
                          ? true
                          : false
                      }
                      error={fieldValidation[9]}
                      className={classes.inputsForm}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </SpecialInputmask>
              </span>
            )}
            {manifParams.manifInfosProfil?.ChampDemande[0].champJob && (
              <span>
                <SpecialTextField
                  id="Person_Job"
                  name="Person_Job"
                  label="Profession"
                  type="text"
                  variant="outlined"
                  style={{ width: "100%" }}
                  required={
                    hisAdmin
                      ? false
                      : obligatoire?.champJob_obligatoire
                      ? true
                      : false
                  }
                  error={fieldValidation[10]}
                  value={person.Person_Job}
                  onChange={(e) => handleFormChange(e)}
                  className={classes.inputsForm}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <WorkIcon />
                      </InputAdornment>
                    ),
                  }}
                  values={
                    doublon.length > 0
                      ? doublon.map((obj) => obj.personne?.Person_Job)
                      : []
                  }
                />
              </span>
            )}
            {paramsConfig.Tshirt && (
              <span>
                <ButtonGroup
                  caria-label="outlined primary button group"
                  className={classes.inputsForm}
                  style={{ width: "100%" }}
                >
                  <Button disabled style={{ borderRight: "1px solid grey" }}>
                    <FontAwesomeIcon icon={faTshirt} size="lg" />
                  </Button>
                  <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                    error={fieldValidation[11]}
                    required={hisAdmin ? false : true}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Tshirt
                    </InputLabel>
                    <SpecialSelect
                      id="Person_Tshirt"
                      name="Person_Tshirt"
                      label="Tshir"
                      value={person.Person_Tshirt}
                      onChange={(e) => handleFormChange(e)}
                      style={{ width: "100%" }}
                      values={
                        doublon.length > 0
                          ? doublon.map((obj) => obj.personne?.Person_Tshirt)
                          : []
                      }
                    >
                      <MenuItem value={""} key={""}></MenuItem>
                      <MenuItem value={"XS"} key={"XS"}>
                        XS
                      </MenuItem>
                      <MenuItem value={"S"} key={"S"}>
                        S
                      </MenuItem>
                      <MenuItem value={"M"} key={"M"}>
                        M
                      </MenuItem>
                      <MenuItem value={"L"} key={"L"}>
                        L
                      </MenuItem>
                      <MenuItem value={"XL"} key={"XL"}>
                        XL
                      </MenuItem>
                      <MenuItem value={"XXL"} key={"XXL"}>
                        XXL
                      </MenuItem>
                    </SpecialSelect>
                  </FormControl>
                </ButtonGroup>
              </span>
            )}
            {manifParams.manifInfosProfil?.afficheNewsLetter && (
              <ButtonGroup
                aria-label="outlined primary button group"
                style={{
                  border: fieldValidation[14]
                    ? "1px solid red"
                    : "1px solid grey",
                  width: "100%",
                }}
                className={classes.inputsForm}
              >
                <Button
                  style={{
                    borderRight: fieldValidation[13]
                      ? "1px solid red"
                      : "1px solid grey",
                    color: "black",
                  }}
                >
                  <FiberNewIcon />
                </Button>
                <RadioGroup
                  row
                  aria-label="Sexe"
                  id="Person_AcceptNewsletter"
                  name="Person_AcceptNewsletter"
                  value={person.Person_AcceptNewsletter}
                  onChange={handleFormChange}
                  style={{ margin: 8 }}
                >
                  <FormLabel style={{ marginTop: "12px", marginRight: "10px" }}>
                    J’accepte de recevoir la newsletter
                  </FormLabel>
                  <FormControlLabel
                    value="true"
                    control={<Radio color="primary" />}
                    label="Oui"
                    checked={person.Person_AcceptNewsletter === "true"}
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio color="primary" />}
                    label="Non"
                    checked={
                      !person.Person_AcceptNewsletter ||
                      person.Person_AcceptNewsletter === "false"
                    }
                  />
                </RadioGroup>
              </ButtonGroup>
            )}
            {!fromProfil && (
              <ButtonGroup
                caria-label="outlined primary button group"
                style={{ marginLeft: "-80%", margin: 8, width: "100%" }}
              >
                <Button style={{ borderRight: "1px solid grey" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z" />
                  </svg>
                </Button>
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  <InputLabel>Attributs</InputLabel>
                  <SpecialSelect
                    id="Person_Attributs"
                    name="Person_Attributs"
                    multiple
                    label="Attribut"
                    valAccessor="value" // Propriété à utiliser comme valeur d'élément
                    style={{ width: "100%" }}
                    value={person.Person_Attributs?.map((it) => ({
                      value: it.id || it.value,
                      name: it.name,
                    }))}
                    onChange={(e) => handleAttrChange(e)}
                    renderValue={(selected) =>
                      selected.map((item) => item.name).join(",")
                    }
                    values={
                      doublon.length > 0
                        ? doublon.flatMap((obj) =>
                            obj.personne?.Person_Attributs?.map((it) => ({
                              value: it.id || it.value,
                              name: it.name,
                            }))
                          )
                        : []
                    }
                    doublon={doublon.map((obj) =>
                      obj.personne?.Person_Attributs?.map((it) =>
                        it.value ? it.value : it.id
                      )
                    )}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    {listAttributs &&
                      listAttributs.map((attr, i) => (
                        <MenuItem value={attr} key={attr.id}>
                          <Checkbox
                            color="primary"
                            checked={
                              person.Person_Attributs.map(
                                (item) => item.id
                              ).indexOf(attr.id) > -1
                            }
                          />
                          <ListItemText primary={attr.name} />
                        </MenuItem>
                      ))}
                  </SpecialSelect>
                </FormControl>
              </ButtonGroup>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {!fromProfil && (
            <SpecialTextField
              id="Person_Commentaire"
              name="Person_Commentaire"
              label="Commentaire"
              type="text"
              variant="outlined"
              style={{ width: "calc(100% - 30px)", marginLeft: "-0px" }}
              required={false}
              value={person.Person_Commentaire}
              onChange={(e) => handleFormChange(e)}
              className={classes.inputsForm}
              values={
                doublon.length > 0
                  ? doublon.map((obj) => obj.personne?.Person_Commentaire)
                  : []
              }
            />
          )}
        </Grid>
        {manifParams.manifInfosProfil?.ChampDemande[0].champLangue && (
          <Grid item xs={12} style={{ overflow: "visible" }}>
            <ButtonGroup
              style={{ width: "calc(100% - 30px)", marginLeft: "-0px" }}
              caria-label="outlined primary button group"
              className={classes.inputsForm}
            >
              <Button disabled style={{ borderRight: "1px solid grey" }}>
                <LanguageIcon style={{ color: "black" }} />
              </Button>
              <FormControl
                variant="outlined"
                style={{ width: "calc(100% - 30px)", marginLeft: "-0px" }}
                error={fieldValidation[12]}
                required={
                  hisAdmin
                    ? false
                    : obligatoire?.champLangue_obligatoire
                    ? true
                    : false
                }
              >
                <InputLabel>Langues</InputLabel>
                <SpecialSelect
                  id="Person_Langue"
                  name="Person_Langue"
                  multiple
                  label="Langues"
                  style={{ width: "100%" }}
                  value={person.Person_Langue}
                  onChange={(e) => handleLangueChange(e)}
                  renderValue={(selected) => {
                    return selected.map((item) => item.name).join(",");
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  values={
                    doublon.length > 0
                      ? LanguagesSelect.filter(
                          (objet) =>
                            doublon
                              .filter(
                                (obj) =>
                                  obj.personne && obj.personne?.Person_Langue
                              ) // Filtrer les éléments sans personne ou sans Person_Langue
                              .map((obj) => obj.personne?.Person_Langue) // Obtenir les valeurs de Person_Langue
                              .some(
                                (tableau) =>
                                  tableau && tableau.includes(objet.value)
                              ) // Vérifier si la valeur est incluse dans l'un des tableaux
                        )
                      : []
                  }
                  doublon={doublon.map((obj) => obj.personne?.Person_Langue)}
                >
                  {LanguagesSelect.map((attr, i) => (
                    <MenuItem value={attr} key={attr.value}>
                      <Checkbox
                        color="primary"
                        key={attr.value}
                        checked={
                          person.Person_Langue?.map(
                            (item) => item.value
                          ).indexOf(attr.value) > -1
                        }
                      />
                      <ListItemText primary={attr.name} />
                    </MenuItem>
                  ))}
                </SpecialSelect>
              </FormControl>
            </ButtonGroup>
          </Grid>
        )}
        {/* informations complémentaires */}
        <Grid container spacing={1} style={{ overflow: "visible" }}>
          {loadPersonIsDown &&
            fieldComplementaireConfig?.map((value, index) => (
              <Grid key={value.idInfoComple} item xs={12} md={6}>
                <TextField
                  id={value.idInfoComple}
                  name={value.idInfoComple}
                  label={value.nomInfoComple}
                  type="text"
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={
                    value.champsObligatoireInfoComple
                      ? complemantaireError[index]?.error
                      : false
                  }
                  onChange={(e) =>
                    hendelChangeInfoComp(value.idInfoComple, e.target.value)
                  }
                  required={value.champsObligatoireInfoComple}
                  defaultValue={
                    person.Person_InfosComples?.InfosComplementaires
                      ? person.Person_InfosComples?.InfosComplementaires[index]
                          ?.valeur
                      : ""
                  }
                  className={classes.inputsForm}
                  helperText={
                    complemantaireError[index]?.error
                      ? "Ce champ est obligatoire"
                      : value.remarqueChamp !== "" && value.remarqueChamp
                  }
                />
              </Grid>
            ))}
        </Grid>
        <Grid container justifyContent={fromProfil && "flex-end"}>
          {!fromProfil && (
            <Grid item xs={12} md={!fromProfil ? 6 : 12}>
              <Button
                variant="contained"
                style={{
                  margin: 8,
                  width: "97%",
                  backgroundColor: "#d32f2f",
                  color: "white",
                }}
                onClick={handleCloseForm}
              >
                Fermer
              </Button>
            </Grid>
          )}
          <Grid item xs={12} md={!fromProfil ? 6 : 12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ margin: 8 }}
              onClick={fromDoublon ? handleFusion : saveInfosBen}
            >
              {fromDoublon ? "Fusionner" : "Enregistrer"}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* formulaire update psw */}
      <Dialog
        open={openUpdatePsw}
        onClose={handleCloseUpdatePsw}
        aria-labelledby="updatePsw-dialog-title"
      >
        <DialogTitle id="updatePsw-dialog-title">
          Modifier le mot de passe
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="psw"
            label="Modifier le mot de passe"
            type="password"
            required={true}
            style={{ width: "100%" }}
            value={psw}
            onChange={handleChangePsw}
            error={pswError}
            helperText={pswError && pswErrorMsg}
          />
          <br />
          <br />
          <TextField
            id="pswConfirm"
            label="Confirmez le mot de passe"
            type="password"
            required={true}
            style={{ width: "100%" }}
            value={pswConfirm}
            onChange={handleChangePswConfirm}
            error={pswConfirmError}
            helperText={pswConfirmError && pswConfirmErrorMsg}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseUpdatePsw}
            color="primary"
            variant="contained"
          >
            Fermer
          </Button>
          <Button
            onClick={handleUpdatePswConfirm}
            color="primary"
            variant="contained"
          >
            Modifier mon mot de passe
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    manif: state.manif,
  };
};

export default connect(mapStateToProps)(FormulaireBenevole);
